import React from 'react';
import { cs } from '@bbkAdminUtils/css-utils';
import Icons from '@bbkAdminUtils/icons';

type Props = {
  badgeIconClasses?: string;
  icon: keyof typeof Icons;
};

export const BadgeIcon: React.FC<Props> = (props) => {
  const { badgeIconClasses, icon } = props;
  return (
    <span className={cs('bbk-badge-icon', badgeIconClasses)}>
      {Icons[icon]}
    </span>
  );
};
